import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.promotion.management.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_PROMOTION_ASYNC: `${uid}.savePromotionAsync`,
    SAVE_PROMOTION_SUCCESS: `${uid}.savePromotionSuccess`,
    SAVE_PROMOTION_FAILURE: `${uid}.savePromotionFailure`,
    UPLOAD_ASYNC: `${uid}.uploadAsync`,
    UPLOAD_SUCCESS: `${uid}.uploadSuccess`,
    UPLOAD_FAILURE: `${uid}.uploadFailure`,
    REMOVE: `${uid}.removeImage`,
    CREATE_PROMOTION: `${uid}.createPromotion`
};

export { ActionTypes };